import { NgModule } from '@angular/core';
import { DatePickerModule } from 'primeng/datepicker';
import { DirectiveModule } from '@shared/directive/directive.module';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { ListboxModule } from 'primeng/listbox';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelModule } from 'primeng/panel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SplitButtonModule } from 'primeng/splitbutton';
import { StepsModule } from 'primeng/steps';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TimelineModule } from 'primeng/timeline';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { DividerModule } from 'primeng/divider'
import { FluidModule } from 'primeng/fluid';

const primeNgModules = [
  AccordionModule,
  AutoCompleteModule,
  ButtonModule,
  CardModule,
  CheckboxModule,
  ConfirmDialogModule,
  DatePickerModule,
  DialogModule,
  DirectiveModule,
  DividerModule,
  DynamicDialogModule,
  FileUploadModule,
  IconFieldModule,
  InputGroupModule,
  InputGroupAddonModule,
  InputIconModule,
  InputMaskModule,
  InputNumberModule,
  InputTextModule,
  ListboxModule,
  MenuModule,
  MessageModule,
  MultiSelectModule,
  FluidModule,
  PanelModule,
  ProgressSpinnerModule,
  RadioButtonModule,
  SelectButtonModule,
  SelectModule,
  SplitButtonModule,
  StepsModule,
  TableModule,
  TabsModule,
  TextareaModule,
  TimelineModule,
  ToastModule,
  ToggleSwitchModule,
  TooltipModule,
];

@NgModule({
  imports: [...primeNgModules],
  exports: [...primeNgModules],
})
export class PrimeNgModule {}
